<template>
    <div class="float-left mr-1">
        <b-button
            variant="warning"
            v-if="mostrarBtnImportarDirf"
            @click.stop="importarDirf()"
            title="Importar DIRF"
        >
            <i class="fa fa-upload"></i> Importar DIRF
        </b-button>
        <b-modal id="modalForm" v-model="mostrarModal" @show="preencherForm()">
            <div slot="modal-title">
                DIRF -
                <b-badge variant="warning">{{ operacao }}</b-badge>
            </div>
            <app-erros-box
                :erros="erros"
                v-if="erros.length > 0"
            ></app-erros-box>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label>Arquivo</label>
                        <b-form-file
                            v-model="arquivo"
                            :state="Boolean(arquivo)"
                            placeholder="Selecione o arquivo..."
                            ref="arquivoInput"
                            browse-text="Selecionar"
                        ></b-form-file>
                    </b-form-group>
                </b-col>
            </b-row>
            <div slot="modal-footer">
                <b-button variant="secondary" @click.stop="fecharModal()"
                    >Cancelar</b-button
                >
                <b-button
                    variant="primary"
                    :disabled="$v.$invalid"
                    @click.stop="salvarArquivo()"
                    class="ml-2"
                    >Salvar</b-button
                >
            </div>
        </b-modal>
    </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import DirfsServicos from './DirfsServicos'

export default {
    props: {
        expressoAtivo: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            mostrarModal: false,
            obterDirfsAtualizadas: false,
            operacao: 'UPLOAD',
            erros: [],
            arquivo: null
        }
    },

    methods: {
        importarDirf() {
            this.mostrarModal = true
        },

        fecharModal() {
            this.mostrarModal = false
            this.resetForm()
            if (this.obterDirfsAtualizadas) {
                this.$emit('obterDirfsAtualizadas')
            }
        },

        resetForm() {
            this.erros = []
            this.arquivo = null
            this.$nextTick(() => {
                this.$v.$reset()
            })
        },

        preencherForm() {
            // this.obterEntregaAtualizada = false
        },

        salvarArquivo() {
            this.mostrarModal = false
            this.$store.dispatch('addRequest')
            let dirfData = {
                arquivo: this.arquivo
            }
            DirfsServicos.inserirDirf(dirfData).then(response => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            'DIRF inserida com sucesso!',
                            'OK',
                            this.$toastConfig.success
                        )
                        this.obterDirfsAtualizadas = true
                        this.resetForm()
                        this.fecharModal()
                    } else {
                        this.erros = response.errors
                        this.mostrarModal = true
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    },

    created() {},

    computed: {
        mostrarBtnImportarDirf() {
            return this.$temAcesso('DIRFS-01')
        }
    },

    watch: {},

    validations: {
        arquivo: {
            required
        }
    }
}
</script>
